import Panel from './panel';
import { tagOnClick } from '../utils';

export default class UploadingPanel extends Panel {
  render() {
    tagOnClick(this.getTag('back-button'), () => {
      this.parent.transitionToPanel('share');
    });
  }

  activate() {
    const progress = this.getTag('upload-progress');
    const bar = progress && progress.subtags.find(t => t.classNames.match(/upload-progress-bar/));

    if (bar && this.parent.upload) {
      bar.element.style.width = 0;

      this.parent.upload.onprogress = e => {
        if (e.lengthComputable) {
          const uploadPercent = (e.loaded / e.total) * 100;
          bar.element.style.width = `${uploadPercent}%`;
        }
      };
    }
  }

  deactivate() {
    this.parent.upload = null;
  }
}
